/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { useQuery, gql } from '@apollo/client';
import { handleApolloError } from '@exo/frontend-common-apollo';
import { useSessionContext } from '@exo/frontend-common-session-context';

export const useSellPriceRange = (catentryId, fetchPolicy,skipCondition?) => {
  const session = useSessionContext()
  // const variables = {
  //   request :{
  //       type: "byPartNumbers",
  //       currency: "CAD",
  //       partNumber:partNumber,
  //       checkEntitlement: false
  //   }
  // };

  const variables = {
        request: {
            catalogEntryId: catentryId,
            currency: "CAD",
            profileName: "IBM_Store_EntitledPrice_RangePrice_Sell_All",
            type: "byCatalogEntryIdsSell"
        }
    };

  const PRICE_GQL = gql`
  query SellPrice($request: SecureStorageSellPriceInput!) {
    sellPrice(request: $request) {
      rangedPrices {
        price {
          value
          currency
        }
        minimumQuantity
        maximumQuantity
      }
      unitPrice {
        value
        currency
      }
      productId
      partNumber
      contractId
    }
  }  
  `;

  const GET_DISPLAY_INDICATIVE_PRICE_RANGE = gql`
      query RangePrice($request: IndicativePriceInRangeInput!) {
      getDisplayIndicativePriceInRange(request: $request) {
      EntitledPrice {
        RangePrice {
          currency
          maximumQuantity {
            uom
            value
          }
          minimumQuantity {
            uom
            value
          }
          priceInRange {
            currency
            value
          }
        }
        UnitPrice {
          price {
            currency
            value
          }
          quantity {
            uom
            value
          }
        }
        contractId
        partNumber
        productId
      }
      resourceId
      resourceName
    }
  }
      `;
  const currentTime = Date.now();
  const timeRemaining = session?.targetTimer ? (session.targetTimer - currentTime) / (1000 * 60) : 0;
  const { loading, error, data, refetch } = useQuery(GET_DISPLAY_INDICATIVE_PRICE_RANGE, {
    variables,
    fetchPolicy: fetchPolicy,
    skip: skipCondition,
    context:{clientName:"/price"}
  });
  handleApolloError(__filename, error);

  const dataSellPrice = data?.getDisplayIndicativePriceInRange?.EntitledPrice[0];
  return { error, loading, dataSellPrice, refetch };
};
